import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../request';

const ProtectedRoute = ({ children }) => {
  
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await api.get('/auth/check');
        if (res.data.authenticated) {
          localStorage.setItem('stepping4life_user', JSON.stringify(res.data.user));
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.log('Auth check failed', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) return null; // or a spinner

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
